import React, { Component } from "react";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import MUIDataTable from "mui-datatables";
import { Button, MuiThemeProvider } from "@material-ui/core";
import { CloudDownload } from "@material-ui/icons";
import { saveAs } from 'file-saver';
import { write, utils } from 'xlsx';
import * as actions from "./actions";
import vertikalTheme from "../../../lib/theme";
import moment from "moment";
import Spinner from "../../common/spinner";
import StaticLoader from "../../common/loader/StaticLoader";

class Transactions extends Component {
  constructor(props) {
    super(props);
    this.state = {
      page: 0,
      rowsPerPage: 10,
      filters: [],
      filtersObj: {},
      dialogFilters: [],
      isExporting: false,
      prefilter: { initialProjectName: '' },
      forceMUIrender: new Date().toISOString(),
      orderBy: 'timestamp',
      orderDirection: 'desc',
      searchText: ''
    };

    this.columns = [
      {
        name: "ProjectName",
        label: this.props.local.strings.transactions.list.projectNameColumn,
      },
      {
        name: "projectNumber",
        label: this.props.local.strings.transactions.list.projectNumberColumn,
      },
      {
        name: "transactionType",
        label: this.props.local.strings.transactions.list.transactionTypeColumn,
        options: {
          filterType: "dropDown",
        },
      },
      {
        name: "entityType",
        label: this.props.local.strings.transactions.list.idTypeColumn,
        options: {
          filterType: "dropDown",
        },
      },
      {
        name: "entityId",
        label: this.props.local.strings.transactions.list.idColumn,
      },
      {
        name: "details",
        label: this.props.local.strings.transactions.list.detailsColumn,
        options: {
          filter: false,
        },
      },
      {
        name: "performedBy",
        label: this.props.local.strings.transactions.list.performedByColumn,
        options: {
          filter: false,
        },
      },
      {
        name: "timestamp",
        label: this.props.local.strings.transactions.list.dateColumn,
        options: {
          customBodyRender: (value) => {
            return (
              <React.Fragment>
                {value ? moment(value).utc().format("MM/DD/yyyy:hh:mm:ss A") : ""}
              </React.Fragment>
            );
          },
        },
      },
    ];
  }

  async componentDidMount() {
    this.props.actions.fetchTransactionsInsuredProjects(this.props.insuredId);
    await this.fetchTransactionTypes();
    this.loadFiltersFromState();
     this.setState({
      filters: [],
      filtersObj: {},
      dialogFilters: [],
      prefilter: { initialProjectName: '' },
      forceMUIrender: new Date().toISOString()
    }, () => {
      if (this.props.certProjectId) {
        this.applyPreFilter();
      } else {
        this.fetchTransactions(0, this.state.rowsPerPage);
      }
    });
  }

  componentDidUpdate(prevProps) {
    if (!prevProps.isActive && this.props.isActive) {
      return;
    }

    if (
      this.props.transactionsProjectInsuredData.length > 0 &&
      prevProps.transactionsProjectInsuredData.length === 0
    ) {
      if (this.props.certProjectId) {
        this.applyPreFilter();
      } else {
        this.fetchTransactions(0, this.state.rowsPerPage);
      }
    }
  }

  applyPreFilter = () => {
    if (!this.props.certProjectId) return;

    const matching = this.props.transactionsProjectInsuredData.find(
      pi => pi.ProjectID == this.props.certProjectId
    );

    if (!matching || !matching.ProjectName) {
      this.setState({
        prefilter: { initialProjectName: '' },
        filters: [],
        dialogFilters: []
      }, () => {
        this.fetchTransactions(0, this.state.rowsPerPage);
      });
      return;
    }

    const preName = matching.ProjectName;
    const initialFilters = [[preName]];

    this.setState({
      prefilter: { initialProjectName: preName },
      filters: initialFilters,
      dialogFilters: initialFilters,
      forceMUIrender: new Date().toISOString()
    }, () => {
      this.handleApplyFilters();
    });
  };

  fetchTransactions = async (page = this.state.page, rowsPerPage = this.state.rowsPerPage) => {
    const { actions, insuredId } = this.props;
    await actions.fetchTransactions({
      insuredId,
      ...this.state.filtersObj,
      // sort: "timestamp_desc",
      page: page + 1, // API pages start from 1
      pageSize: rowsPerPage,
    });
  }

  fetchTransactionTypes = async () => {
    const { actions } = this.props;
    await actions.fetchTransactionTypes();
  }

  handleChangePage = (page) => {
    this.setState({ page }, () => {
      this.fetchTransactions();
    });
  }

  handleChangeRowsPerPage = (rowsPerPage) => {
    this.setState({ rowsPerPage, page: 0 }, () => {
      this.fetchTransactions();
    });
  }

  handleApplyFilters = () => {
    const { filters } = this.state;
    const { transactionTypes = [], entityTypes = [] } = this.props.transactions;
    const { transactionsProjectInsuredData, actions } = this.props;

    const transactionTypeCodeMap = transactionTypes.reduce((acc, type) => {
      acc[type.label] = type.code;
      return acc;
    }, {});

    const entityTypeCodeMap = entityTypes.reduce((acc, type) => {
      acc[type.label] = type.code;
      return acc;
    }, {});

    const filtersObj = {};
    let hasValidFilters = false;
    let projectNameFilter = null;
    let projectNumberFilter = null;

    filters.forEach((filter, index) => {
      if (filter && filter.length > 0) {
        const columnName = this.columns[index].name;
        const filterText = filter[0]; // Assuming single filter value for text fields
        if (columnName === 'entityId') {
          const trimmed = (filter[0] || '').trim();
          if (trimmed) {
            filtersObj.entityId = trimmed;
            hasValidFilters = true;
          }
        } else if (columnName === 'entityType') {
          filtersObj.entityTypeCode = filter.map(label => entityTypeCodeMap[label]).join(',');
          hasValidFilters = true;
        } else if (columnName === 'transactionType') {
          filtersObj.types = filter.map(label => transactionTypeCodeMap[label]).join(',');
          hasValidFilters = true;
        } else if (columnName === 'ProjectName') {
          projectNameFilter = filterText.toLowerCase();
        } else if (columnName === 'projectNumber') {
          projectNumberFilter = filterText.toLowerCase();
        }
      }
    });

    if (projectNameFilter || projectNumberFilter) {
      const matches = transactionsProjectInsuredData.filter(p => {
        const nameMatches = projectNameFilter
          ? (p.ProjectName || '').toLowerCase().includes(projectNameFilter)
          : true;

        const numberMatches = projectNumberFilter
          ? (p.ProjectNumber || '').toLowerCase().includes(projectNumberFilter)
          : true;

        return nameMatches && numberMatches;
      });

      if (matches.length > 0) {
        filtersObj.projectId = matches.map(p => p.ProjectID).join(',');
        hasValidFilters = true;
      }
    }

    this.setState({ filtersObj, page: 0 }, () => {
      if (hasValidFilters) {
        this.fetchTransactions();
      } else {
        // No valid filters (e.g., no match for Project Name/Number), empty the list
        const noFiltersApplied = filters.every(f => !f || f.length === 0);
        if (noFiltersApplied) {
          this.fetchTransactions();
        } else {
          actions.setList([]);
          actions.setTotalAmount(0);
        }
      }
    });
    // Save filters to state
    this.props.actions.setTransactionFilters(filters, filtersObj);
  }

  loadFiltersFromState = () => {
    const { filters, filtersObj } = this.props.transactions;
    if (filters && filters.length > 0) {
      this.setState({ filters, filtersObj, dialogFilters: filters }, () => {
        this.handleApplyFilters();
      });
    }
  }

  handleSearchChange = (searchText) => {
    this.setState({ searchText, page: 0 });
  }

  filterBySearchText = (data) => {
    const { searchText } = this.state;
    if (!searchText || searchText.trim() === '') {
      return data;
    }

    const lowerSearchText = searchText.toLowerCase();
    return data.filter(transaction => {
      const formattedTimestamp = transaction.timestamp
      ? moment(transaction.timestamp).utc().format("MM/DD/yyyy:hh:mm:ss A")
      : "";
      const searchableFields = [
        transaction.ProjectName,
        transaction.projectNumber,
        transaction.transactionType,
        transaction.entityType,
        transaction.entityId,
        transaction.details,
        transaction.performedBy,
        formattedTimestamp
      ];

      return searchableFields.some(field =>
        field && String(field).toLowerCase().includes(lowerSearchText)
      );
    });
  }

  handleExcelExport = async () => {
    const { insuredId } = this.props;
    const { filtersObj } = this.state;
    const { transactionTypes = [], entityTypes = [] } = this.props.transactions;
    const { transactionsProjectInsuredData = [] } = this.props;

    this.setState({ isExporting: true });

    try {
      const queryParams = {
        insuredId,
        ...filtersObj,
        pageSize: 10000,
        page: 1
      };

      const response = await this.props.actions.fetchTransactionsForExport(queryParams);
      const responseData = response.data || response;
      const exportList = responseData.rows || responseData.data || [];

      if (!exportList || exportList.length === 0) {
        console.warn('No data available for export');
        this.setState({ isExporting: false });
        return;
      }

      // Map the data to match column names for export
      const transactionTypeMap = transactionTypes.reduce((acc, type) => {
        acc[type.code] = type.label;
        return acc;
      }, {});
      const entityTypeMap = entityTypes.reduce((acc, type) => {
        acc[type.code] = type.label;
        return acc;
      }, {});

      const mappedData = exportList.map(transaction => {
        const mapping = transactionsProjectInsuredData.find(p => p.ProjectID === transaction.projectId) || {};
        return {
          ProjectName: mapping.ProjectName || transaction.ProjectName,
          ProjectNumber: mapping.ProjectNumber || transaction.projectNumber,
          TransactionType: transactionTypeMap[transaction.transactionType] || transaction.transactionType,
          IdType: entityTypeMap[transaction.entityType] || transaction.entityType,
          ID: transaction.entityId,
          Details: transaction.details,
          PerformedBy: transaction.performedBy,
          Date: transaction.timestamp ? moment(transaction.timestamp).utc().format("MM/DD/yyyy:hh:mm:ss A") : ""
        };
      });

      if (mappedData.length === 0) {
        console.warn('No mapped data available for export');
        this.setState({ isExporting: false });
        return;
      }

      // Create worksheet and workbook
      const ws = utils.json_to_sheet(mappedData);
      const wb = utils.book_new();
      utils.book_append_sheet(wb, ws, 'Transactions');

      const buffer = write(wb, { bookType: 'xlsx', type: 'array' });
      const blob = new Blob([buffer], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
      
      if (blob.size === 0) {
        console.error('Generated blob is empty');
        this.setState({ isExporting: false });
        return;
      }

      saveAs(blob, 'transactions_export.xlsx');
    } catch (error) {
      console.error('Export error:', error);
      alert('Error exporting transactions. Please try again.');
    } finally {
      this.setState({ isExporting: false });
    }
  }

  render() {
    const {
      projectNameColumn,
      projectNumberColumn,
      transactionTypeColumn,
      idTypeColumn,
      idColumn,
      detailsColumn,
      performedByColumn,
      dateColumn,
      filterBtn,
    } = this.props.local.strings.transactions.list;

    const { list, fetching, transactionTypes = [], entityTypes = [] } = this.props.transactions;
    const { transactionsProjectInsuredData } = this.props;

    // Create maps for code to label
    const transactionTypeMap = transactionTypes.reduce((acc, type) => {
      acc[type.code] = type.label;
      return acc;
    }, {});

    const entityTypeMap = entityTypes.reduce((acc, type) => {
      acc[type.code] = type.label;
      return acc;
    }, {});

    const mappedList = list.map(transaction => {
      const mapping = transactionsProjectInsuredData.find(p => p.ProjectID === transaction.projectId) || {};
      return {
        ...transaction,
        ProjectName: mapping.ProjectName || transaction.projectName || 'N/A',
        projectNumber: mapping.ProjectNumber || transaction.projectNumber || 'N/A',
        transactionType: transactionTypeMap[transaction.transactionType] || transaction.transactionType,
        entityType: entityTypeMap[transaction.entityType] || transaction.entityType,
      };
    });

    const { orderBy, orderDirection } = this.state;
    const sortedList = [...mappedList].sort((a, b) => {
      const aValue = a[orderBy] != null ? a[orderBy] : '';
      const bValue = b[orderBy] != null ? b[orderBy] : '';
      const direction = orderDirection === 'asc' ? 1 : -1;
      if (orderBy === 'timestamp') {
        return (Date.parse(aValue) - Date.parse(bValue)) * direction;
      }
      return String(aValue).localeCompare(String(bValue)) * direction;
    });

    const filteredBySearchList = this.filterBySearchText(sortedList);

    const columns = [
      {
        name: "ProjectName",
        label: projectNameColumn,
        options: {
          filterType: "textField",
          ...(this.props.certProjectId && this.state.prefilter.initialProjectName && {
                filterList: [this.state.prefilter.initialProjectName]
              })
        },
      },
      {
        name: "projectNumber",
        label: projectNumberColumn,
        options: {
          filterType: "textField",
        },
      },
      {
        name: "transactionType",
        label: transactionTypeColumn,
        options: {
          filterType: "dropDown",
          filterOptions: transactionTypes.map(type => type.label),
          customBodyRender: (value) => transactionTypeMap[value] || value,
        },
      },
      {
        name: "entityType",
        label: idTypeColumn,
        options: {
          filterType: "dropDown",
          filterOptions: entityTypes.map(type => type.label),
          customBodyRender: (value) => entityTypeMap[value] || value,
        },
      },
      {
        name: "entityId",
        label: idColumn,
        options: {
          filterType: "textField",
        },
      },
      {
        name: "details",
        label: detailsColumn,
        options: {
          filter: false,
        },
      },
      {
        name: "performedBy",
        label: performedByColumn,
        options: {
          filter: false,
        },
      },
      {
        name: "timestamp",
        label: dateColumn,
        options: {
          filter: false,
          customBodyRender: (value) => {
            return (
              <React.Fragment>
                {value ? moment(value).utc().format("MM/DD/yyyy:hh:mm:ss A") : ""}
              </React.Fragment>
            );
          },
        },
      },
    ];

    const { totalAmountOfTransactions } = this.props.transactions;
    const {page, rowsPerPage, filters} = this.state;
    const options = {
      serverSide: true,
      count: totalAmountOfTransactions,
      page: page,
      rowsPerPage: rowsPerPage,
      filterList: filters,
      filter: true,
      sort: true,
      sortOrder: {
        name: this.state.orderBy,
        direction: this.state.orderDirection,
      },
      onColumnSortChange: (changedColumn, direction) => {
        this.setState({ orderBy: changedColumn, orderDirection: direction });
      },
      onChangePage: this.handleChangePage,
      onChangeRowsPerPage: this.handleChangeRowsPerPage,
      download: false,
      filterType: "multiselect",
      selectableRowsHeader: false,
      selectableRowsHideCheckboxes: true,
      print: false,
      responsive: "standard",
      fixedHeader: true,
      tableBodyHeight: "410px",
      jumpToPage: true,
      search: true,
      searchOpen: false,
      searchPlaceholder: "Search transactions...",
      onSearchChange: this.handleSearchChange,
      setTableProps: () => {
        return {
          size: "small",
        };
      },
      setFilterChipProps: (colIndex, colName, filterValue) => {
        const column = this.columns[colIndex];
        let displayValue = filterValue;
        if (column.options && column.options.filterType === 'textField') {
          displayValue = filterValue;
        } else {
          displayValue = Array.isArray(filterValue) ? filterValue.join(', ') : filterValue;
        }
        return {
          label: `${this.columns[colIndex]["label"].toUpperCase()} ${displayValue}`,
        };
      },
      onFilterChange: (changedColumn, filterList, type) => {
        this.setState({ filters: filterList });
      },
      onFilterChipClose: (index, removedFilter, filterList) => {
        this.setState({ 
          filters: filterList,
          prefilter: { initialProjectName: '' }
        }, () => {
          this.handleApplyFilters();
        });
      },
      customFilterDialogFooter: (filterList, onFilterUpdate, onReset) => (
        <div style={{ display: 'flex', justifyContent: 'space-between', padding: '3px', marginTop: '30px' }}>
          <Button
            style={{
              color: 'rgba(0, 0, 0, 0.87)',
              boxShadow: '0px 3px 1px -2px rgba(0, 0, 0, 0.2), 0px 2px 2px 0px rgba(0, 0, 0, 0.14), 0px 1px 5px 0px rgba(0, 0, 0, 0.12)',
              backgroundColor: '#e0e0e0',
              padding: '0px 16px',
            }}
            onClick={() => {
              if (onReset) onReset();
              this.setState({ 
                filters: [],
                filtersObj: {},
                dialogFilters: [],
                prefilter: { initialProjectName: '' },
                searchText: '',
                forceMUIrender: new Date().toISOString()
              }, () => {
                this.fetchTransactions();
              });
            }}
          >
            Reset
          </Button>
          <Button
            variant="contained"
            color="primary"
            onClick={() => {
              this.setState({ filters: filterList }, () => {
                this.handleApplyFilters();
                onFilterUpdate(filterList);
              });
            }}
          >
            Apply Filters
          </Button>
        </div>
      ),
    };

    return (
      <React.Fragment>
        <div className="list-view admin-view-body transactions-list">
          <div style={{ marginBottom: '20px', display: 'flex', justifyContent: 'flex-end' }}>
            <Button
              variant="contained"
              size="medium"
              onClick={this.handleExcelExport}
              disabled={this.state.isExporting}
              style={{
                backgroundColor: '#8CC739',
                color: 'white',
                textTransform: 'uppercase',
                fontWeight: 'bold',
                display: 'flex',
                alignItems: 'center'
              }}
            >
              <CloudDownload style={{ fontSize: '17px', marginRight: '5px' }} />
              {this.state.isExporting ? 'Exporting...' : 'Export'}
            </Button>
          </div>
          <MuiThemeProvider theme={vertikalTheme.getMuiTheme()}>
            <MUIDataTable
              key={this.state.forceMUIrender}
              title={"Insured Transactions"}
              data={filteredBySearchList}
              columns={columns}
               options={{
                ...options,
                textLabels: {
                  body: {
                    noMatch: fetching ? <StaticLoader /> : "No transaction records found.",
                  },
                },
              }}
            />
          </MuiThemeProvider>
        </div>
      </React.Fragment>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    transactions: state.transactions,
    local: state.localization,
    transactionsProjectInsuredData: state.transactions.transactionsProjectInsuredData || []
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    actions: bindActionCreators(actions, dispatch),
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(Transactions);
